import React from "react";
import { localStorage } from "../../../services";
import {  LocalStorageKey } from "../../../models";
import { useSelector } from "react-redux";
import { selectUserInfo } from "../../../routes/Auth/auth.ducks";
import PhoneNumbers from "../../PhoneNumbers";

const ContactNumbers = (props) => {
  const draftData = localStorage.getItem(LocalStorageKey.savedForm);
  const userData = useSelector(selectUserInfo); 
  
  return (
    <PhoneNumbers
        {...props}
        isFormPage={true}
        userProfile={userData}
        draftData={draftData}
        isAdminRoute={false}
        adminUserId={null}
      />
     
  );
};



export default ContactNumbers;



// WEBPACK FOOTER //
// ./src/components/FormControls/ContactNumbers/ContactNumbers.tsx